// extracted by mini-css-extract-plugin
export default {"wholeTableReservationWrapper":"pSN2JJ","mobile":"eHHq7N","occupied":"vZKVyh","selected":"D3wxg9"};